/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { META_COLLECT_API } from '../../../api';
import { useSigninContext } from '../../../context/AuthProviderPages/Signin';
import { LoadingData } from '../../LoadingData';
import * as S from './styled';
//  Esse componente DischargeInfo busca na API e renderiza os dados de descarga disparados pelo usuário a partir do componente DescargaSelecionada.
interface IDischargeResponse {
  DFIDCOLETA: number;
  DFDATAINICIODESCARGA: string | null;
  DFHORAINICIODESCARGA: string | null;
  DFDATAFIMDESCARGA: string | null;
  DFHORAFIMDESCARGA: string | null;
  DFBOCAS: Array<{
    DFBOCA: number;
    DFTEMPERATURA: string | number;
    DFLACRE?: string;
  }>;
  DFDESCARGASILO: Array<{
    DFIDSILO: number;
    DFVOLUME: number;
    DFDATADESCARGA: string;
    DFHORADESCARGA: string;
  }>;
}
const DischargeInfo = () => {
  const { collectionOrder } = useParams();
  const { path } = useSigninContext();
  const [loading, setLoading] = useState(true);
  const [dischargeData, setDischargeData] = useState<IDischargeResponse | null>(
    null,
  );
  useEffect(() => {
    if (!collectionOrder) {
      setLoading(false);
      return;
    }
    setLoading(true);
    META_COLLECT_API.get<IDischargeResponse>('/descarga', {
      params: { DFIDCOLETA: collectionOrder },
      headers: { path },
    })
      .then(res => {
        setDischargeData(res.data);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Erro ao carregar dados da descarga');
        setLoading(false);
      });
  }, [collectionOrder, path]);
  if (loading) {
    return (
      <S.ContainerPage>
        <S.PageContent>
          <LoadingData title="Carregando dados!" />
        </S.PageContent>
      </S.ContainerPage>
    );
  }
  const totalVolume = dischargeData?.DFDESCARGASILO?.reduce((acc, silo) => {
    // Converte para número e soma. Se não houver valor, soma 0.
    return acc + (Number(silo.DFVOLUME) || 0);
  }, 0);
  return (
    <S.PageContent>
      <S.DeschargeContent>
        <h2>Dados da Descarga</h2>
        <div className="row-input">
          <div className="column-input">
            <label>
              <b>Data início</b>
            </label>
            <input
              type="date"
              value={dischargeData?.DFDATAINICIODESCARGA || ''}
              readOnly
            />
          </div>
          <div className="column-input">
            <label>
              <b>Hora início</b>
            </label>
            <input
              type="time"
              value={dischargeData?.DFHORAINICIODESCARGA || ''}
              readOnly
            />
          </div>
          <div className="column-input">
            <label>
              <b>Data fim</b>
            </label>
            <input
              type="date"
              value={dischargeData?.DFDATAFIMDESCARGA || ''}
              readOnly
            />
          </div>
          <div className="column-input">
            <label>
              <b>Hora fim</b>
            </label>
            <input
              type="time"
              value={dischargeData?.DFHORAFIMDESCARGA || ''}
              readOnly
            />
          </div>
        </div>
        <div className="line" />
        <h2>Bocas do Veículo</h2>
        <div className="row-input">
          {dischargeData?.DFBOCAS?.map(boca => (
            <div
              key={boca.DFBOCA}
              className="column-input"
              style={{ gap: '10px' }}
            >
              <label>
                <b>Boca {boca.DFBOCA}</b>
              </label>
              <div className="dataMouths">
                <label>Temperatura (C°)</label>
                <input value={boca.DFTEMPERATURA ?? ''} readOnly />
              </div>
              <div className="dataMouths">
                <label>Lacre</label>
                <input value={boca.DFLACRE || ''} readOnly />
              </div>
            </div>
          ))}
        </div>
        <div className="line" />
        <h2>Silos de Descarga</h2>
        <div className="ContainerSilo">
          {dischargeData?.DFDESCARGASILO?.map((silo, index) => (
            <div key={index}>
              <label>
                <b>Silo {silo.DFIDSILO}</b>
              </label>
              <div className="column-input">
                <label>Volume</label>
                <input value={silo.DFVOLUME || '0'} readOnly />
              </div>
              <div className="column-input">
                <label>Data da Descarga</label>
                <input
                  value={
                    silo.DFDATADESCARGA
                      ? new Date(silo.DFDATADESCARGA).toLocaleDateString(
                          'pt-BR',
                          { timeZone: 'UTC' },
                        )
                      : ''
                  }
                  readOnly
                />
              </div>
              <div className="column-input">
                <label>Hora</label>
                <input value={silo.DFHORADESCARGA || ''} readOnly />
              </div>
            </div>
          ))}
        </div>
        <div className="totalVolumeBox">
          <h4>Total</h4>
          <span>{totalVolume}L</span>
        </div>
      </S.DeschargeContent>
    </S.PageContent>
  );
};
export { DischargeInfo };
